
import Vue from 'vue'
import { CurrentCategory, Category as SidebarCategory } from '@/model/category'
import { ProductCategory as SidebarProductCategory } from '@/model/productCategory'
import { SidebarShortestShippingDate } from '@/categories/types'
import { store } from './store'

import ShippingDates from '@/common/components/sidebar/ShippingDates.vue'
import RelatedCategories from '@/common/components/sidebar/RelatedCategories.vue'
import ProductCategories from '@/common/components/sidebar/ProductCategories.vue'
import PaymentInfo from '@/common/components/sidebar/PaymentInfo.vue'
import ProductSearch from '@/common/components/sidebar/ProductSearch.vue'
import FacetSearch from '@/common/components/sidebar/FacetSearch.vue'
import { getCategoryFacets_productSearchResults_facets as FacetData } from '@/categories/types/getCategoryFacets'
import { MaxQuantityPrice  } from '@/common/types/maxQuantityPrice'
import FacetList from '@/common/components/facets/FacetsList.vue'
const unavailable = '-'

export default Vue.extend({
  components: {
    // NOTE: VueComponent.name option is not working...
    SidebarShippingDates: ShippingDates,
    SidebarRelatedCategories: RelatedCategories,
    SidebarProductCategories: ProductCategories,
    SidebarPaymentInfo: PaymentInfo,
    SidebarSearch: ProductSearch,
    SidebarFacet: FacetSearch,
    SidebarFacetList: FacetList
  },
  props: {
    rootCategory: {
      type: Object as () => SidebarCategory,
      required: true
    },
    parentCategory: {
      type: Object as () => SidebarCategory,
      required: false,
      default: null
    },
    childCategories: {
      type: Array as () => SidebarCategory[],
      required: true
    },
    siblingCategories: {
      type: Array as () => SidebarCategory[],
      required: true
    },
    productCategories: {
      type: Array as () => SidebarProductCategory[],
      required: true
    },
    shortestShippingDates: {
      type: Object as () => SidebarShortestShippingDate,
      required: true
    } ,
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  computed: {
    facetData(): FacetData[] {
      return store.state.facetData
    },
    singleColorShippingDate(): string {
      const date = this.shortestShippingDates.table.single_color
      if (!date) {
        return unavailable
      }
      return date
    },
    fullColorShippingDate(): string {
      const date = this.shortestShippingDates.table.full_color
      if (!date) {
        return unavailable
      }
      return date
    },
    singleColorSampleShippingDate(): string | null {
      return this.shortestShippingDates.table.single_color_sample
    },
    fullColorSampleShippingDate(): string | null{
      return this.shortestShippingDates.table.full_color_sample
    },
    currentCategory(): CurrentCategory {
      return {
        id: this.rootCategory.id,
        name: this.rootCategory.short_display_name
      }
    },
    hasParent(): boolean {
      return !!this.parentCategory
    },
    isRelatedCategoryVisible(): boolean {
      return this.childCategories.length > 0 || (this.hasParent && this.siblingCategories.length > 0)
    },
    sidebarVisible(): boolean {
      return window.innerWidth > 1024
    }
  },
  created() {
    const categoryId = store.state.sidebar.rootCategory?.id
    if (categoryId) store.fetchCategoryFacet([categoryId])
  }
})
